import { put, call } from "redux-saga/effects";
import { toast } from "react-toastify";
import { offerListFailure, offerListSuccess } from "../../Actions";
import { api } from "../../Config/ApiInterface";

function* offerListSaga(action) {
  try {
    const response = yield call(api.post, `/room/offer-list`);
    yield put(offerListSuccess(response));
    toast.success(response.message);
  } catch (error) {
    yield put(offerListFailure(error));
  }
}

export default offerListSaga;
